export default "__VITE_ASSET__BfK3XLvX__"